import type { ParentSettingsV1, ParentStorageState } from "./parentTypes";
import { parseParentSettingsJson, serializeParentSettings } from "./parentValidation";

export const PARENT_SETTINGS_STORAGE_KEY = "perfect-draw-parent-settings-v1";

export class ParentStorageError extends Error {
  public constructor(message: string) {
    super(message);
    this.name = "ParentStorageError";
  }
}

export function readParentSettings(storage: Storage | null): ParentStorageState {
  if (!storage) return { kind: "corrupt", reason: "Parent settings storage is unavailable." };
  let raw: string | null;
  try {
    raw = storage.getItem(PARENT_SETTINGS_STORAGE_KEY);
  } catch {
    return { kind: "corrupt", reason: "Parent settings storage is unavailable." };
  }
  if (raw === null) return { kind: "unconfigured" };
  try {
    return { kind: "valid", settings: parseParentSettingsJson(raw) };
  } catch {
    return { kind: "corrupt", reason: "The Parent Mode configuration is damaged." };
  }
}

export function writeParentSettings(storage: Storage | null, settings: ParentSettingsV1): void {
  const serialized = serializeParentSettings(settings);
  if (!storage) throw new ParentStorageError("Parent settings could not be saved on this device.");
  try {
    storage.setItem(PARENT_SETTINGS_STORAGE_KEY, serialized);
  } catch {
    throw new ParentStorageError("Parent settings could not be saved on this device.");
  }
}

export function removeParentSettings(storage: Storage | null): void {
  if (!storage) throw new ParentStorageError("Parent settings could not be reset on this device.");
  try {
    storage.removeItem(PARENT_SETTINGS_STORAGE_KEY);
  } catch {
    throw new ParentStorageError("Parent settings could not be reset on this device.");
  }
}
